import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { Plan } from "./getPlansV2";
export const Response = Plan;
export const url = (planId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account/v2/plans/${planId}/status`
        : `https://middleware.uat.farther.com/account/v2/plans/${planId}/status`;
};
export default async function setPlanStatusV2(planId, newStatus, config) {
    const { data } = await axios.put(url(planId), { status: newStatus }, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${setPlanStatusV2.name} Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=setPlanStatusV2.js.map